import React from 'react'
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/app/hooks'

interface OtherPlatformLinkProps {
  url: string
}

export const OtherPlatformLink = ({ url }: OtherPlatformLinkProps) => {
  const { t } = useTranslation()
  const design = useAppSelector(state => state.design)
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" css={[linkStyle, css({ color: design?.theme.brandColor })]}>
      {t('Write a review on other platforms')}
    </a>
  )
}

const linkStyle = css({
  marginBottom: '2.5rem',
  textDecoration: 'none',
  fontSize: '12px',
  display: 'block',
  textAlign: 'center',
})
